import clientAPI from "@/api/ClientAPIMixin.js";
import i18n from '@/plugins/i18n.js';

const CustomerContactEditModel = {
    headerTitle: i18n.t('servicesystem.common_objects.contact.customer_contact'),
    enabledIcon: "mdi-account-tie",
    disabledIcon: "mdi-account-off",
    listItemTextKey: "Name",
    ParentIdKey: "CustomerId",

    fields: [
        { type: "input", label: i18n.t('servicesystem.common_objects.contact.name'), valuekey: "Name", editable: true, rules: "noempty", defaultValue: "" },
        { type: "input", label: i18n.t('servicesystem.common_objects.contact.email'), valuekey: "Email", editable: true, rules: "noempty, email", defaultValue: "", coloredby: "EmailAllowed" },
        { type: "input", label: i18n.t('servicesystem.common_objects.contact.mobile'), valuekey: "Mobile", editable: true, rules: "noempty, tlf", priorityslot: "phone", defaultValue: "", coloredby: "SmsAllowed" },
        { type: "input", label: i18n.t('servicesystem.common_objects.contact.land_line'), valuekey: "FixedPhone", editable: true, rules: "tlf", priorityslot: "phone", defaultValue: "" },
        { type: "input", label: i18n.t('servicesystem.common_objects.contact.title'), valuekey: "Title", editable: true, rules: "", defaultValue: "" },

        { type: "switch", label: i18n.t('servicesystem.common_objects.contact.allow_sms'), valuekey: "SmsAllowed", editable: "onlyedit", rules: { tiedto: "Mobile" }, defaultValue: false },
        { type: "switch", label: i18n.t('servicesystem.common_objects.contact.allow_email'), valuekey: "EmailAllowed", editable: "onlyedit", rules: { tiedto: "Email" }, defaultValue: false },
        { type: "switch", label: i18n.t('servicesystem.common_objects.contact.active'), valuekey: "IsActive", editable: "onlyedit", defaultValue: true },
    ],

    viewMore: {
        routeName: "ViewCustomerContact",
        params: { customerId: "Id" }
    },

    methods: {
        async save(contact) {
            return clientAPI.methods.changeCustomerContactById(contact);
        },
        async create(newcontact) {
            return clientAPI.methods.createCustomerContact(newcontact);
        },
        async getlist(customerid) {
            return clientAPI.methods.getCustomerContactsByCustomerId(customerid);
        },
    }
}

export default CustomerContactEditModel;